import PractitionerTable from './PractitionerTable';

export default PractitionerTable;
